import { useMutation } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { CompetitionType } from 'src/types/domain.types';
import { toast } from 'react-toastify';
import { RoutesKeys } from '../../enums/routesKeys.enum';
import { useNavigate } from 'react-router-dom';
import { useGetCompetitionsQuery } from './getCompetitions';

const createCompetition = (competition: CompetitionType) =>
  api.post('/competitions', competition);

export const useCreateCompetitionMutation = () => {
  const navigate = useNavigate();
  const { refetch } = useGetCompetitionsQuery();

  return useMutation({
    mutationKey: ['competitions'],
    mutationFn: createCompetition,
    onSuccess: () => {
      toast.success('Competition created');
      navigate(RoutesKeys.competitions);
      refetch();
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
